export default __webpack_public_path__ + "static/icon-adjustable-cups-6b7957bb9e52612e2532eb948f7cd092.webp";